/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import React, { createContext, useContext } from 'react';

function createHookContext(hook) {
  var Context = /*#__PURE__*/createContext(null);
  function Provider(props) {
    return /* @__PURE__ */React.createElement(Context.Provider, {
      value: hook(props.value)
    }, props.children);
  }
  function use() {
    return useContext(Context);
  }
  return {
    Provider: Provider,
    use: use
  };
}

export { createHookContext };
//# sourceMappingURL=createHookContext.js.map
